import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import Api, { apiPaths } from 'app/services/api';
import useAuth from 'app/hooks/useAuth';
import { authRoles } from 'app/auth/authRoles';
import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Box, Button, Dialog, Icon, IconButton, TextField } from '@mui/material';
import { Title } from '@mui/icons-material';
import { translate } from 'translate';

const roleFields = {
  finance: {},
};

const WarrantyCards = () => {
  const { user } = useAuth();
  const roles = user.roles;
  const [showDialog, setShowDialog] = useState(false);
  const [count, setCount] = useState(0);

  const columns = [
    { name: 'Serial Number', key: 'warranty_number' },
    { name: 'Store', key: 'store_name' },
    { name: 'Create Date', key: 'created_at', type: 'date', sort: true },
  ];
  const StoreManagercolumns = [
    { name: 'Serial Number', key: 'warranty_number' },
    { name: 'Store', key: 'store_name' },
    { name: 'Status', key: 'paid', render: (row) => (row.paid ? 'فعال‌شده' : 'فروخته‌نشده') },
    {
      name: 'Commission',
      key: 'store_commission',
      render: (row) =>
        row.paid && (
          <span className={`${row.store_commission > 0 ? 'text-green-500' : ''}`}>
            {row.store_commission}
          </span>
        ),
    },
    { name: 'Create Date', key: 'created_at', type: 'date', sort: true },
  ];

  const filtersOn = [
    { name: 'Date From', key: 'created_at_min', type: 'date' },
    { name: 'Date To', key: 'created_at_max', type: 'date' },
    { name: 'Serial Number', key: 'warranty_number' },
    {
      name: 'Store',
      key: 'store_uuid_exact',
      type: 'auto_complete',
      options: { entity: 'stores', path: apiPaths.STORES },
      auth: ['admin'],
      // show: { key: 'type', value: 'organisational' },
    },
    { name: 'deleted', key: 'deleted', type: 'switch' },
    { name: 'Activated', key: 'paid', type: 'switch' },
  ];
  const isStoreManager =
    !roles.includes('admin') && !roles.includes('sa') && roles.includes('store_manager');

  const handleAdd = () => {
    setShowDialog(true);
  };
  const handleSubmit = () => {
    console.log(count);
    Api.post(apiPaths.CARD_REQUESTS, { count }).then((res) => {
      enqueueSnackbar(translate('Request sent successfully'), { variant: 'success' });
    });
    setShowDialog(false);
  };

  return (
    <div className="m-sm-30">
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Warranties"
          path="warranties"
          apipath={`${apiPaths.WARRANTIES}${isStoreManager ? '/store' : ''}`}
          defaultFilter={{ paid_bool: isStoreManager ? undefined : false }}
          columns={isStoreManager ? StoreManagercolumns : columns}
          filtersOn={filtersOn}
          hideActions={isStoreManager ? ['view', 'edit', 'delete'] : ['view']}
          createLabel={isStoreManager ? 'Request new card' : undefined}
          handleAdd={isStoreManager ? handleAdd : undefined}
          // showExport
        />
      </SimpleCard>
      {showDialog && (
        <Dialog onClose={() => setShowDialog(false)} open={showDialog}>
          <div className="p-6">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {translate('count')}
              <IconButton onClick={() => setShowDialog(false)}>
                <Icon>close</Icon>
              </IconButton>
            </Box>
            <div className="flex flex-col">
              <TextField value={count} onChange={(e) => setCount(e.target.value)} />
              <Button className="mt-4" variant="contained" onClick={handleSubmit}>
                {translate('submit')}
              </Button>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default WarrantyCards;
